import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aea4b87a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container_content" }
const _hoisted_3 = { class: "content_watch" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wchat_tip" }, "1.获取公众号信息", -1))
const _hoisted_5 = { class: "watch_text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "apiAppId(应用ID):", -1))
const _hoisted_7 = { class: "text_input" }
const _hoisted_8 = { class: "watch_text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "apiAppSecret(应用密钥):", -1))
const _hoisted_10 = { class: "text_input" }
const _hoisted_11 = { class: "footer_btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.appid,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.obj.appid) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.appsecret,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.obj.appsecret) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}